import { useState, useEffect } from "react";
import { getEditorsChoiceCarouselWidget } from "../api/widgets/editorsChoiceCarousel/requests";

function useStoryblokEditorsChoiceWidget(payload) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getEditorsChoiceCarouselWidget(payload)
      .then((data) => {
        if (data) {
          setData(data);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .then(() => setIsLoading(false));
  }, []);

  return [data, isLoading];
}

export { useStoryblokEditorsChoiceWidget };

